import { Box, Typography } from "@mui/material";
import Card from "../../../components/card/Card";
import { TFunction } from "i18next";
import { ManageButton, signinBoxStyles, signinUserEmailStyles, StyledEmailBox, StyledPasswordBox, StyledWidgetText, widgetCardContentStyles, widgetCardHeaderStyles } from "../styles";
import CheckIcon from "../../../icons/Check";
import { CredentialContainer } from "../../../api/representations";
import { useNavigate } from "react-router-dom";
import { StyledChip } from "../../../components/styles";

interface SignInWidgetProps {
    t: TFunction;
    resourceUrl: string;
    credentials?: CredentialContainer[];
    loading: boolean;
    userEmail: string;
}

export default function SignInWidget({ t, resourceUrl, loading, credentials, userEmail }: SignInWidgetProps) {
    const navigate = useNavigate();

    const basicAuthenticationCategory = credentials?.find((credential) => credential.category === 'basic-authentication');

    return (
        <Card title={t('signingIn')} sxContent={widgetCardContentStyles} sxHeader={widgetCardHeaderStyles}>
            <Box sx={signinBoxStyles}>
                <Box>
                    <img src={`${resourceUrl}/images/signIn.svg`} alt={t('signingIn')} />
                </Box>
                    {!!basicAuthenticationCategory?.userCredentialMetadatas.length ? (
                        <>
                        <StyledEmailBox>
                            <Typography>{t('email')}:</Typography>
                            <Typography sx={signinUserEmailStyles}>{userEmail}</Typography>
                        </StyledEmailBox>
                        <StyledPasswordBox>
                            <Typography>{t('password-display-name')}:</Typography>
                            <StyledChip icon={<CheckIcon />} size="small" label="Secure" color="success" variant="outlined" />
                        </StyledPasswordBox>
                        </>
                    ) : 
                        <StyledWidgetText variant="body1">{t('personalSignIn')}</StyledWidgetText>
                    }

                {!!basicAuthenticationCategory?.userCredentialMetadatas.length ?
                    <ManageButton variant="contained" size="small" onClick={() => navigate('account-security/signing-in')}>{t('managePassword')}</ManageButton> :
                    <ManageButton variant="contained" size="small" onClick={() => navigate('account-security/signing-in')}>{t('manage')}</ManageButton>
                }
            </Box>
        </Card>
    );
}